import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { usePortalAuth } from '../auth/authContexts'
import { isDevMode } from '../utils/devMode'
import PostLoginLoadingScreen from './PostLoginLoadingScreen'

/**
 * Layout route that renders child routes only when the user has a portal session.
 * Unauthenticated visitors are redirected to sign-in; dev mock mode bypasses the gate.
 */
export default function RequireAuth() {
  const { isAuthenticated, isLoading } = usePortalAuth()
  const location = useLocation()

  if (isDevMode()) {
    return <Outlet />
  }

  if (isLoading) {
    return <PostLoginLoadingScreen />
  }

  if (!isAuthenticated) {
    return <Navigate to="/signin" replace state={{ from: location.pathname }} />
  }

  return <Outlet />
}
